import axiosClient from './axiosClient';

const url = 'api/Product';
export const subscriptionRankApi = {
  getSubscriptionRankApi: () => {
    return axiosClient.get(`${url}/rankbooks`);
  },
};
